module.exports = __webpack_public_path__ + "static/media/inactive-left-shield.9608fe8a.svg";